import React from 'react';
import { Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import AppFilterGrid from '../layout/AppFilterGrid';
import { useDispatch, useSelector } from 'react-redux';
import { TypeTiers } from '../../constants/enums';
import ClientAutoC from '../AutoComplete/ClientAutoC';
import FournisseurAutoC from '../AutoComplete/FournisseurAutoC';
import EmployeAutoC from '../AutoComplete/EmployeAutoC';
import { AppDispatch } from '../../reduxStore/Store';
import { setCompteFilters, fetchComptes } from '../../reduxStore/compteSlice';
import { fetchEtatCaisse } from '../../reduxStore/ReglementSlice';
import { GeneriqueData, Tiers } from '../../models/models';
import SelectCaisse from '../Selects/SelectCaisse';
import { labels } from '../../constants/labels';

const CompteFilters: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { compteFilters } = useSelector((state: any) => state.CompteSlice); // vérifie le nom du slice
  // Type de compte lu dans le store (pas d'état local) : il survit au démontage du
  // filtre — changement d'onglet, aller-retour vers un document. La remise à zéro des
  // filtres est faite par la page (Comptes.tsx) à l'ouverture, pas ici au démontage.
  const tiersType: string = compteFilters?.tiers_type ?? TypeTiers.CLIENT;

  const handleTiersTypeChange = (event: SelectChangeEvent) => {
    const type = event.target.value as TypeTiers;
    dispatch(setCompteFilters({ ...compteFilters, tiers_type: type, tiers_id: null, tiers: null }));
  };

  const handleTiersChange = (tiers: Tiers | null) => {
    dispatch(setCompteFilters({ ...compteFilters, tiers_id: tiers ? tiers.id : null, tiers }));
  };

  
    const handleOnCaisseChange = (caisse: GeneriqueData | null) => {
     dispatch(
      setCompteFilters({
        ...compteFilters,
        caisse_id: caisse ? caisse.id : 0,
        caisse: caisse, // Ensure it updates the object
      }));
    
    };


  const handleDateChange = (field: 'startDate' | 'endDate') => (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setCompteFilters({ ...compteFilters, [field]: event.target.value }));
  };
  const renderTiersAutoC = () => {
    switch (tiersType) {
      case TypeTiers.CLIENT:
        return (
          <ClientAutoC
            onClientChange={handleTiersChange}
            selectedClient={compteFilters?.tiers}
          />
        );
      case TypeTiers.FOURNISSEUR:
        return (
          <FournisseurAutoC
            onFournisseurChange={handleTiersChange}
            selectedFournisseur={compteFilters?.tiers}
          />
        );
      case TypeTiers.EMPLOYE:
        return (
          <EmployeAutoC
            onEmployeChange={handleTiersChange}
            selectedEmploye={compteFilters?.tiers}
          />
        );
      default:
        return (
          <SelectCaisse
          onCaisseChange={handleOnCaisseChange}
          selectedCaisse={compteFilters.caisse} />
        );
    }
  };

  return (
    // Pas de padding propre : la page (Comptes.tsx) enveloppe déjà le filtre dans un Box p:2.
    <AppFilterGrid minItemWidth={180} sx={{ p: 0 }}>
      <FormControl fullWidth size="small">
        <InputLabel id="tiers_type">Type de Compte</InputLabel>
        <Select
          labelId="tiers_type"
          value={tiersType}
          onChange={handleTiersTypeChange}
          label="Type de Compte"
        >
          <MenuItem value={TypeTiers.CLIENT}>{labels.client}</MenuItem>
          <MenuItem value={TypeTiers.FOURNISSEUR}>{labels.fournisseur}</MenuItem>
          <MenuItem value={TypeTiers.EMPLOYE}>{labels.employe}</MenuItem>
          <MenuItem value="CAISSE">Caisse</MenuItem>
        </Select>
      </FormControl>

      {renderTiersAutoC()}

      <TextField
        label="Date Début"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={compteFilters?.startDate || ''}
        onChange={handleDateChange('startDate')}
        size="small"
        fullWidth
        required
      />

      <TextField
        label="Date Fin"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={compteFilters?.endDate || ''}
        onChange={handleDateChange('endDate')}
        size="small"
        fullWidth
        required
      />

      <Button variant="outlined" color="primary" fullWidth sx={{ height: 40 }} onClick={() => {
          // "Afficher" = nouvelle recherche → toujours repartir page 1
          // (sinon, si on était page 5/5 et le nouveau résultat tient sur 1 page,
          // on tomberait sur un offset hors plage avec data = []).
          const refreshed = { ...compteFilters, offset: 0 };
          dispatch(setCompteFilters({ offset: 0 }));
          if (refreshed.tiers_type === 'CAISSE') {
            dispatch(fetchEtatCaisse(refreshed));
          } else {
            dispatch(fetchComptes(refreshed));
          }
        }}>
          Afficher
        </Button>
    </AppFilterGrid>
  );
};

export default CompteFilters;
